<template>
  <div id="horaires_modifications">
    <router-link :to="`/horaires${$route.params.date ? '/gestion' : ''}`">
      <img class="imgicon" src="img/back.png" />
    </router-link>
    <h2>Modification des horaires</h2>
    <div class="form-inline mb-3">
      <label class="mr-2" for="enddate">Jour à modifier :</label>
      <button @click="changeDate(false)" class="btn">
        <font-awesome-icon :icon="'arrow-left'" />
      </button>
      <date-picker type="date" format="dd DD/MM/YYYY" @change="onDateSelected" v-model="date"></date-picker>
      <button @click="changeDate(true)" class="btn">
        <font-awesome-icon :icon="'arrow-right'" />
      </button>
      <button @click="save" class="btn btn-success ml-5 btn-sm">Sauvegarder les modifications</button>
      <form v-on:submit.prevent="search">
        <input
          type="text"
          class="form-control ml-5"
          name="search"
          placeholder="Référence"
          id="search"
          v-model="searchId"
        />
      </form>
      <button @keyup.enter="search" @click="search" class="btn btn-info ml-1">
        <font-awesome-icon :icon="'search'" />
      </button>
    </div>
    <div v-for="site of sites" :key="site.id" class="card">
      <div class="card-header">
        <h5>
          {{site.nom}}
          <button
            @click="addHoraire(site.id)"
            class="float-right btn btn-success btn-sm"
          >
            Ajouter un horaire&nbsp;
            <font-awesome-icon :icon="'plus'" />
          </button>
        </h5>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table" v-if="horaires[site.id].length > 0">
            <thead>
              <tr>
                <th scope="col">Référence</th>
                <th scope="col">Employé</th>
                <th scope="col">Fonction</th>
                <th scope="col">Séances</th>
                <th scope="col">Options</th>
                <th scope="col">Remarque</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="horaire of horaires[site.id]"
                v-bind:key="horaire.id"
                :class="horaire.highlight ? 'table-warning' : (horaire.sib ? 'graybg' : '')"
                :id="`h${horaire.id}`"
              >
                <td>{{horaire.id >= 0? horaire.id: '-'}}</td>
                <td>
                  <select v-model="horaire.id_employe" class="custom-select custom-select-sm">
                    <option selected :value="undefined">-</option>
                    <option :value="null">QSP</option>
                    <option
                      v-for="employe of employes"
                      :key="employe.id"
                      :value="employe.id"
                    >{{employe.acronyme}} - {{employe.nom}} {{employe.prenom}}</option>
                  </select>
                </td>
                <td>
                  <select v-model="horaire.id_fonction" class="custom-select custom-select-sm">
                    <option selected :value="undefined">-</option>
                    <option
                      v-for="fonction of fonctions"
                      :key="fonction.id"
                      :value="fonction.id"
                    >{{fonction.nom}}</option>
                  </select>
                </td>
                <td>
                  <div class="form-inline">
                    <div class="custom-control custom-checkbox">
                      <input
                        class="custom-control-input"
                        :id="`h10-${horaire.id}`"
                        type="checkbox"
                        v-model="horaire.h10"
                        label="10h"
                      />
                      <label class="custom-control-label" :for="`h10-${horaire.id}`">10h&nbsp;</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input
                        class="custom-control-input"
                        :id="`h14-${horaire.id}`"
                        type="checkbox"
                        v-model="horaire.h14"
                        label="14h"
                      />
                      <label class="custom-control-label" :for="`h14-${horaire.id}`">14h&nbsp;</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input
                        class="custom-control-input"
                        :id="`h18-${horaire.id}`"
                        type="checkbox"
                        v-model="horaire.h18"
                        label="18h"
                      />
                      <label class="custom-control-label" :for="`h18-${horaire.id}`">18h&nbsp;</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input
                        class="custom-control-input"
                        :id="`h20-${horaire.id}`"
                        type="checkbox"
                        v-model="horaire.h20"
                        label="20h"
                      />
                      <label class="custom-control-label" :for="`h20-${horaire.id}`">20h&nbsp;</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input
                        class="custom-control-input"
                        :id="`matin-${horaire.id}`"
                        type="checkbox"
                        v-model="horaire.matin"
                        label="Matin"
                      />
                      <label class="custom-control-label" :for="`matin-${horaire.id}`">Matin&nbsp;</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input
                        class="custom-control-input"
                        :id="`apresmidi-${horaire.id}`"
                        type="checkbox"
                        v-model="horaire.apresmidi"
                        label="Après-midi"
                      />
                      <label
                        class="custom-control-label"
                        :for="`apresmidi-${horaire.id}`"
                      >Après-midi&nbsp;</label>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      :id="`sib-${horaire.id}`"
                      v-model="horaire.sib"
                    />
                    <label class="custom-control-label" :for="`sib-${horaire.id}`">SiB</label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      :id="`visible-${horaire.id}`"
                      v-model="horaire.visible"
                    />
                    <label class="custom-control-label" :for="`visible-${horaire.id}`">Visible</label>
                  </div>
                </td>
                <td>
                  <input class="form-control" v-model="horaire.remarque" type="text" />
                </td>
                <td>
                  <button @click="delHoraire(horaire.id)" class="btn btn-danger btn-sm">
                    <font-awesome-icon :icon="'trash'" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <h5 class="pt-5" v-else>Pas d'horaire à signaler...</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import api from "@/api";
import moment from "moment";
import utils from "@/utils";
import Vue from "vue";
import VueScrollTo from "vue-scrollto";
import DatePicker from "vue2-datepicker";

Vue.use(VueScrollTo);

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  data() {
    return {
      date: new Date(),
      olddate: moment(new Date()).format("YYYY-MM-DD"),
      sites: [],
      fonctions: [],
      fonctionsById: [],
      employes: [],
      employesById: [],
      rawhoraires: [],
      utils,
      oldhoraires: [],
      searchId: "",
      highlightId: undefined,
    };
  },
  components: { DatePicker },
  async created() {
    this.$store.commit("setLoading", true);
    this.sites = (await api.getSites()).data.sites;
    for (let site of this.sites) {
      this.horaires[site.id] = [];
    }
    this.employes = (await api.getEmployes()).data.employes;
    for (let employe of this.employes) {
      this.employesById[employe.id] = employe;
    }
    this.fonctions = (await api.getFonctions()).data.fonctions;
    for (let fonction of this.fonctions) {
      this.fonctionsById[fonction.id] = fonction;
    }
    if (this.$route.params.id) {
      this.highlightId = this.$route.params.id;
      this.searchId = this.$route.params.id;
      this.search(true);
    } else {
      this.loadHoraires();
    }
    this.$store.commit("setLoading", false);
  },
  methods: {
    async search(atload) {
      let result = await api.getHoraireById(this.searchId);
      if (result.code === 200) {
        this.highlightId = String(result.data.horaire.id);
        if (atload)
          this.olddate = moment(result.data.horaire.date).format("YYYY-MM-DD");
        this.changeDate(false, result.data.horaire.date);
      } else {
        Swal.fire({
          text: result.message,
          type: "warning",
        });
      }
      this.searchId = undefined;
    },
    changeDate(forwards, date) {
      if (date) {
        this.date = new Date(moment(date).format("YYYY-MM-DD"));
      } else {
        if (forwards) {
          this.date = new Date(
            moment(this.date).add(1, "d").format("YYYY-MM-DD")
          );
        } else {
          this.date = new Date(
            moment(this.date).subtract(1, "d").format("YYYY-MM-DD")
          );
        }
      }
      this.loadHoraires();
    },
    onDateSelected(newDate){
      this.date = new Date(moment(newDate).format("YYYY-MM-DD"));
      this.loadHoraires();
    },
    async loadHoraires() {
      let ok = true;
      if (
        this.oldhoraires !== JSON.stringify(this.rawhoraires) &&
        moment(this.date).format("YYYY-MM-DD") !== this.olddate
      ) {
        // Il y a eu du changement...
        await Swal.fire({
          title: `Attention`,
          text: `les modifications que vous avez apporté au ${moment(
            this.date
          ).format(
            "dd DD/MM/YYYY"
          )} ne seront pas enregistrées. Voulez-vous abandonner les modifications ?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Continuer",
          cancelButtonText: "Annuler",
        }).then(async (result) => {
          if (!result.value) {
            ok = false;
            this.date = moment(this.olddate).toDate();
          }
        });
      }
      if (ok && this.date) {
        this.rawhoraires = (
          await api.getHorairesByDate(moment(this.date).format("YYYY-MM-DD"))
        ).data.horaires;
        console.log(this.rawhoraires);
        if (this.highlightId) {
          for (let horaire of this.rawhoraires) {
            if (String(horaire.id) === this.highlightId) {
              horaire.highlight = true;
              setTimeout(() => {
                VueScrollTo.scrollTo(`#h${horaire.id}`, 100, { offset: -200 });
              }, 100);
              this.highlightId = undefined;
              break;
            }
          }
        }
        this.oldhoraires = JSON.stringify(this.rawhoraires);
        this.olddate = moment(this.date).format("YYYY-MM-DD");
      }
    },
    addHoraire(id_site) {
      this.rawhoraires.push({
        id: -1 - this.rawhoraires.length,
        id_site,
        visible: true,
        date: this.date,
        remarque: "",
      }); //ID negatif => nouvel horaire
    },
    delHoraire(id_horaire) {
      for (let horaire of this.rawhoraires) {
        if (horaire.id === id_horaire) {
          if (horaire.id < 0) {
            this.rawhoraires.splice(this.rawhoraires.indexOf(horaire), 1);
          } else {
            horaire.deleted = true;
          }
          break;
        }
      }
      this.$forceUpdate();
      let temp = this.rawhoraires;
      this.rawhoraires = [];
      this.rawhoraires = temp;
    },
    async save() {
      let ok = true;
      for (let horaire of this.rawhoraires) {
        //ATTENTION: horaire.id_employe ne peut pas être undefined mais PEUT être null (QSP)
        if (!(horaire.id_employe !== undefined && horaire.id_fonction)) {
          ok = false;
          break;
        }
      }
      if (ok) {
        let response = await api.updateHoraires(this.rawhoraires);
        Toast.fire({
          type: response.code === 200 ? "success" : "error",
          text: response.message,
        });
        this.loadHoraires();
      } else {
        Swal.fire({
          type: "warning",
          text: "Certains champs ne sont pas remplis !",
        });
      }
    },
  },
  computed: {
    horaires() {
      let horaires = [];
      for (let site of this.sites) {
        horaires[site.id] = [];
        for (let horaire of this.rawhoraires) {
          if (horaire.id_site === site.id && !horaire.deleted) {
            horaires[site.id].push(horaire);
          }
        }
      }
      return horaires;
    },
  },
};
</script>